<script setup lang="ts">

import { computed} from "vue";
import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
import ComplectItem from './ComplectItem.vue'
const $buildingStore = useCalcBuildingStore();
//const listItems = ref([])
const props = defineProps<{ tabType: string}>()
//const data = [/* массив твоих объектов */];

function extractOKNumber(articleCode: any) {
  const match = articleCode.match(/ОК(\d+)/);
  return match ? parseInt(match[1], 10) : Infinity; // Infinity — если нет ОК, чтобы ушло в конец
}

const Doplist = ["gates", "door", "window"];
const listItems = computed(()=>{
    if (props.tabType=="all"){
        return $buildingStore.article.dependencies
    }
    if (props.tabType=="extras") {
        var finalList = $buildingStore.article.dependencies.filter((x: { tabType: string; })=>((x.tabType=='extras')|| (x.tabType=='window') || (x.tabType=='door') || (x.tabType=='gates'))).sort((a:any, b:any) => {
            const numA = Doplist.indexOf(a.tabType);
  const numB = Doplist.indexOf((b.tabType));
  return numB - numA;
});;
        //finalList.filter((x:any) => x.type != 'gate_portal');
        if ($buildingStore.currentColor != 0) {
        return finalList.filter((x:any) => (x.type != 'gate_portal') || (parseInt(x.params.color) == $buildingStore.currentColor))
        } else {
            return finalList
        }
    }
    else{
        
        if (props.tabType=="set")
    {
        const sorted = $buildingStore.article.dependencies.filter((x: { tabType: string; })=>x.tabType==props.tabType).sort((a:any, b:any) => {
            const numA = $buildingStore.colors.indexOf(extractOKNumber(a.articleCode));
  const numB = $buildingStore.colors.indexOf(extractOKNumber(b.articleCode));
  return numB - numA;
});
return sorted
    } else {
        return  $buildingStore.article.dependencies.filter((x: { tabType: string; })=>x.tabType==props.tabType);
    }
}
})
</script>

<template>
    <div class="grid-wrapper">

   
        <div class="grid-complect-items">
                <template v-for="item in listItems" :key="item._id">
                        <ComplectItem :item="item"/>
                </template>
        </div>
    </div>
</template>

<style scoped>
.grid-wrapper{
    padding-top: 24px;
    padding-bottom: 24px;
}
.grid-complect-items{
    display: grid;
  grid-template-columns: repeat(auto-fill, 234px);
  grid-auto-rows: 336px;
  gap: 20px;
  justify-content: start;
  

}
</style>
